import styled, {css} from 'styled-components'

export const UserInfoWrap = styled.div`
    display: flex;
`

export const Avatar = styled.img`
    width: ${({large}) => large ? '84px':'60px'};
    height: ${({large}) => large ? '84px':'60px'};
`

export const UserInfoBody = styled.div`
    margin-left: 12px;
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 767px) {
        margin-left: 8px;
    }
`

export const Username = styled.p`
    color: #222;
    font-size: 18px;
    font-weight: bold;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
    margin-bottom: ${({large}) => large ? '0':'4px'};

    @media screen and (max-width: 767px) {
        font-size: 16px;
        margin-bottom: 2px;
    }
`

export const JoinAt = styled.span`
    opacity: .6;
    color: #222;
    font-size: 13px;
    margin-bottom: ${({large}) => large ? '2px':'4px'};

    @media screen and (max-width: 767px) {
        font-size: 12px;
        margin-bottom: 2px;
    }
`

export const Gender = styled.span`
    opacity: .6;
    color: #222;
    font-size: 13px;
    
    @media screen and (max-width: 767px) {
        font-size: 12px;
        margin-bottom: 2px;
    }
`

export const UserGender = styled.span`
    text-transform: uppercase;
`

export const InputFile = styled.input`
    display: none;
`

const buttonStyle = css`
    margin-top: auto;
    background-color: #eee;
    padding: 6px 18px;
    font-size: 12px;
    color: #222;
    border-radius: 2px;
`

export const ButtonChooseImage = styled.label`
    ${buttonStyle};
    cursor: pointer;
`

export const SocialLogin = styled.div`
    ${buttonStyle};
    cursor: default;
`